import { ValueField } from "./value-field.model";

export class LoginDetails {
    constructor() {
        this.userToken = '';
        this.userId = '';
        this.lblLoginTitle = '';
        this.lblHelpText = '';
        this.contactUs = new ContactUsDetails();
        this.valFlds = [];
    }

    userToken: string;
    userId: string;
    lblLoginTitle: string;
    lblHelpText: string;
    contactUs: ContactUsDetails;
    valFlds: Array<ValueField>;
}

export class ContactUsDetails {
    constructor() {
        this.contactInfo = '';
    }

    contactInfo: string;
}
